import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Container from '@material-ui/core/Container';

import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';

import HideOnScroll from './_hide-on-scroll';
import ScrollTop from './_scroll-top';

import AppbarDesktop from './_appbar_desktop';
import AppbarMobile from './_appbar_mobile';

const useStyles = makeStyles((theme) => ({
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  sectionMobile: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  }
}));

const Navbar = (props) => {
  const classes = useStyles();

  return (
    <>
      <CssBaseline />

      <HideOnScroll>
        <AppBar style={{backgroundColor: 'white'}}>
          <Container
            className={classes.sectionDesktop}
            maxWidth="xl"
          >
            <AppbarDesktop />
          </Container>

          <Container className={classes.sectionMobile}>
            <AppbarMobile />
          </Container>
        </AppBar>
      </HideOnScroll>

      <Toolbar id="back-to-top-anchor" />

      <ScrollTop {...props}>
        <Fab
          aria-label="scroll back to top"
          color="secondary"
          size="medium"
        >
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </>
  );
}

export default Navbar;
